import purify from "dompurify";

export default class Bologna {
    constructor(host) {
        if (!host.startsWith('https://')) {
            host = `https://${host}`;
        }
        if (!host.endsWith('/')) {
            host = `${host}/`;
        }
        this.host = host;
        console.log('Instantiated Bologna Proxy connection with this URI ' + this.host);
    }

    secure_url(path) {
        if (!path.startsWith('/')) {
            path = '/' + path;
        }

        return `${this.host}?target=${purify.sanitize(path)}`;
    }

    broadcastPaste(ev, classid) {
        try {
            jQuery(classid).append(purify.sanitize(`<div class="alert ${ev.cssClass}">${purify.sanitize(ev.simpleMessage || ev.message)}</div>`));
        } catch (ex) {
            console.log(`Could not pass notification to ${classid}: ${ex}`);
        }
    }

    isGuestId(guestId) {
        let regex = /^[0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
        return guestId.match(regex) !== null;
    }
}
